import { createGetExperiment } from 'features/page-model';
import { createFeatureSelector } from 'features/create-feature-selector';
import { createSelector } from 'reselect';
import { getArticle } from 'common/selectors';
import i18next from 'i18next';
import { COMPLEMENTS_PLACEMENT_ID, SUBSTITUTES_PLACEMENT_ID, SUGGESTIONS_PLACEMENT_ID } from './constants';

const getPlacementId = (placementName: string) => {
  return createSelector(createGetExperiment(placementName), (experiment) => experiment?.externalId);
};

const featureSelector = createFeatureSelector('relatedProducts');

export const getSet = createSelector(featureSelector, (f) => f?.set ?? null);
export const getSubstitutes = createSelector(featureSelector, (f) => f?.substitutes ?? []);
export const getComplements = createSelector(featureSelector, (f) => f?.complements ?? []);

export const getCollectionTitle = createSelector(featureSelector, (f) => {
  return f?.collection ? `${i18next.t('carousel-titles.other-collection')} ${f.collection.name}` : '';
});
export const getCollectionMainPhoto = createSelector(featureSelector, (f) => f?.collection?.mainPhoto);
export const getCollectionProducts = createSelector(
  featureSelector,
  getArticle,
  (f, id) => f?.collectionProducts?.filter((productId) => productId !== id) ?? [],
);

export const getComplementsPlacementId = getPlacementId(COMPLEMENTS_PLACEMENT_ID);
export const getSuggestionsPlacementId = getPlacementId(SUGGESTIONS_PLACEMENT_ID);
export const getSubstitutesPlacementId = getPlacementId(SUBSTITUTES_PLACEMENT_ID);
